module.exports = __webpack_public_path__ + "mify_lgotnaya_ipoteka.3697b1a9e7a51ee3e8c97f7c2be6ae39.jpg";